export function checkIsHashActive(hash: string) {
    if (typeof window === 'undefined') return false

    return window.location.hash === `#${hash}`
}
